// Calendrier officiel des réunions du FOMC (décision de taux, 14h00 ET le 2e jour).
// Source : Réserve Fédérale (federalreserve.gov/monetarypolicy/fomccalendars.htm)
export const FOMC_MEETINGS = [
  "2026-01-28T19:00:00Z",
  "2026-03-18T18:00:00Z",
  "2026-04-29T18:00:00Z",
  "2026-06-17T18:00:00Z",
  "2026-07-29T18:00:00Z",
  "2026-09-16T18:00:00Z",
  "2026-10-28T18:00:00Z",
  "2026-12-09T19:00:00Z",
];

export function nextFomc(now = new Date()) {
  for (const iso of FOMC_MEETINGS) {
    const d = new Date(iso);
    if (d > now) return d;
  }
  return null;
}
